export default __webpack_public_path__ + "static/media/sukasi-saritha.ee7bbaba.png";